module.exports = __webpack_public_path__ + "templates.dialog-add-credit-card-b3f31af4.html";